<template>
  <div>
    <!-- Filter -->
    <v-card outlined class="mb-3 no-print">
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="filter.dari"
              type="date"
              label="Dari Tanggal"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="filter.sampai"
              type="date"
              label="Sampai Tanggal"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="filter.kategori"
              :items="items.kategori"
              label="Kategori (semua)"
              outlined
              dense
              clearable
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="filter.pos"
              :items="posItems"
              label="POS (semua)"
              outlined
              dense
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="3" class="d-flex align-center">
            <v-btn
              color="primary"
              :loading="state.loading"
              @click="fetchData"
              class="mr-2"
            >
              Tampilkan
            </v-btn>
            <v-btn color="success" :disabled="!data.length" @click="printDocument">
              Print
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12" class="d-flex flex-wrap align-center">
            <span class="text-caption mr-2">Periode cepat:</span>
            <v-btn x-small outlined class="mr-1 mb-1" @click="setPeriode('today')">
              Hari Ini
            </v-btn>
            <v-btn x-small outlined class="mr-1 mb-1" @click="setPeriode('week')">
              Minggu Ini
            </v-btn>
            <v-btn x-small outlined class="mr-1 mb-1" @click="setPeriode('month')">
              Bulan Ini
            </v-btn>
            <v-btn
              x-small
              outlined
              class="mr-1 mb-1"
              @click="setPeriode('lastMonth')"
            >
              Bulan Lalu
            </v-btn>
            <v-checkbox
              v-model="filter.hanya_selesai"
              label="Hanya yang masuk pelaporan pajak"
              hide-details
              dense
              class="ml-4 mt-0"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-progress-linear
      v-if="state.loading"
      indeterminate
      rounded
      height="6"
      class="no-print"
    ></v-progress-linear>

    <p v-if="state.loaded && !data.length && !state.loading" class="no-print">
      Tidak ada data pengeluaran pada periode ini.
    </p>

    <main
      v-if="data.length && !state.loading"
      class="report"
      id="section-print"
    >
      <div class="d-flex align-center">
        <h1 class="report-title-light mr-5">
          {{ portAwal ? portAwal.text + " - " : "" }}RINCIAN PENGELUARAN KASIR
        </h1>
        <div class="border">
          <h2 class="report-title-light">
            {{ formatDate(appliedFilter.dari) }} s/d
            {{ formatDate(appliedFilter.sampai) }}
          </h2>
        </div>
      </div>
      <p class="mb-0 mt-1" v-if="appliedFilter.kategori || appliedFilter.pos">
        <i>
          {{ appliedFilter.kategori ? "Kategori: " + appliedFilter.kategori : "" }}
          {{ appliedFilter.kategori && appliedFilter.pos ? " | " : "" }}
          {{ appliedFilter.pos ? "POS: " + appliedFilter.pos : "" }}
        </i>
      </p>

      <!-- Rincian -->
      <table class="w-100 mt-3">
        <thead>
          <tr>
            <th width="3%">No</th>
            <th width="7%">No Kas</th>
            <th width="8%">Tanggal</th>
            <th width="10%">Kategori</th>
            <th width="8%">POS</th>
            <th width="10%">Oleh</th>
            <th>Keperluan</th>
            <th width="12%">Rp</th>
            <th width="10%">ACC</th>
            <th width="4%" class="no-print">Pajak</th>
            <th width="5%" class="no-print">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in data" :key="item.id">
            <td class="text-center">{{ idx + 1 }}</td>
            <td class="text-center">{{ item.id }}</td>
            <td class="text-center">{{ formatDate(item.tgl) }}</td>
            <td class="text-center">{{ item.kategori }}</td>
            <td class="text-center">{{ item.pos }}</td>
            <td class="text-center">{{ namaUser(item.oleh) }}</td>
            <td>{{ item.keperluan }}</td>
            <td class="text-right no-wrap">
              Rp. {{ formatCurrency(Math.abs(item.nominal)) }}
            </td>
            <td class="text-center">{{ namaUser(item.acc) }}</td>
            <td class="text-center no-print">
              <v-icon small :color="isSelesai(item) ? 'success' : 'grey'">
                {{ isSelesai(item) ? "mdi-check" : "mdi-minus" }}
              </v-icon>
            </td>
            <td class="text-center no-print">
              <v-btn icon x-small color="primary" @click="openEdit(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr>
            <td colspan="7" class="text-right"><b>Total:</b></td>
            <td class="text-right no-wrap">
              <b>Rp. {{ formatCurrency(total) }}</b>
            </td>
            <td></td>
            <td class="no-print"></td>
            <td class="no-print"></td>
          </tr>
        </tbody>
      </table>

      <!-- Rekap per kategori -->
      <h3 class="report-title-light mt-5">Rekap per Kategori</h3>
      <table class="mt-2 rekap">
        <thead>
          <tr>
            <th>Kategori</th>
            <th>Jumlah Transaksi</th>
            <th>Rp</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rekapKategori" :key="row.kategori">
            <td>{{ row.kategori }}</td>
            <td class="text-center">{{ row.count }}</td>
            <td class="text-right no-wrap">
              Rp. {{ formatCurrency(row.total) }}
            </td>
          </tr>
          <tr>
            <td class="text-right"><b>Total</b></td>
            <td class="text-center">
              <b>{{ data.length }}</b>
            </td>
            <td class="text-right no-wrap">
              <b>Rp. {{ formatCurrency(total) }}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </main>

    <!-- Dialog Edit -->
    <v-dialog v-model="edit.open" max-width="720" persistent>
      <v-card>
        <v-card-title>
          Edit Pengeluaran Kas
          <span class="text-subtitle-1 ml-2">(No Kas: {{ edit.form.id }})</span>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="edit.form.tgl"
                type="date"
                label="Tanggal"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="edit.form.kategori"
                :items="items.kategori"
                label="Kategori"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                v-model="edit.form.pos"
                :items="posItems"
                label="POS Pengeluaran"
                outlined
                dense
                clearable
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editJumlah"
                label="Jumlah"
                prefix="Rp"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="edit.form.oleh"
                :items="items.karyawan"
                label="Oleh"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="edit.form.acc"
                :items="items.karyawan"
                label="ACC"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="edit.form.keperluan"
                label="Untuk Keperluan"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="edit.form.selesai"
                label="Selesai (Masuk Pelaporan Pajak)"
                hide-details
                dense
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="edit.saving" @click="edit.open = false">
            Batal
          </v-btn>
          <v-btn color="primary" :loading="edit.saving" @click="saveEdit">
            Simpan Perubahan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

function toISODate(date) {
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}/.test(date)) {
    return date.substr(0, 10);
  }
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
}

export default {
  name: "RincianPengeluaranKas",
  data() {
    const now = new Date();
    return {
      portAwal: JSON.parse(localStorage.getItem("port_awal") || "null"),
      posItems: ["DECLARING", "JKT PTK", "PTK JKT", "KANTOR"],
      state: {
        loading: false,
        loaded: false
      },
      filter: {
        dari: toISODate(new Date(now.getFullYear(), now.getMonth(), 1)),
        sampai: toISODate(now),
        kategori: null,
        pos: null,
        hanya_selesai: false
      },
      appliedFilter: {},
      items: {
        kategori: [],
        karyawan: []
      },
      data: [],
      edit: {
        open: false,
        saving: false,
        form: {}
      }
    };
  },
  computed: {
    total() {
      return this.data.reduce((a, b) => a + Math.abs(Number(b.nominal) || 0), 0);
    },
    rekapKategori() {
      const map = {};
      this.data.forEach(item => {
        const key = item.kategori || "-";
        if (!map[key]) map[key] = { kategori: key, count: 0, total: 0 };
        map[key].count += 1;
        map[key].total += Math.abs(Number(item.nominal) || 0);
      });
      return Object.values(map).sort((a, b) => b.total - a.total);
    },
    editJumlah: {
      get() {
        return this.formatCurrency(this.edit.form.jumlah || 0);
      },
      set(val) {
        this.edit.form.jumlah = this.convertToAngka(val);
      }
    }
  },
  methods: {
    setPeriode(type) {
      const now = new Date();
      let dari = now;
      let sampai = now;

      if (type === "week") {
        const day = now.getDay() || 7; // Senin sebagai awal minggu
        dari = new Date(now);
        dari.setDate(now.getDate() - day + 1);
      } else if (type === "month") {
        dari = new Date(now.getFullYear(), now.getMonth(), 1);
      } else if (type === "lastMonth") {
        dari = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        sampai = new Date(now.getFullYear(), now.getMonth(), 0);
      }

      this.filter.dari = toISODate(dari);
      this.filter.sampai = toISODate(sampai);
      this.fetchData();
    },
    async fetchData() {
      if (!this.filter.dari || !this.filter.sampai) {
        alert("Tanggal harus diisi");
        return;
      }
      if (this.filter.dari > this.filter.sampai) {
        alert("Tanggal 'Dari' tidak boleh lebih besar dari 'Sampai'");
        return;
      }

      this.state.loading = true;

      try {
        const res = await axios.get("kas/laporan-pengeluaran-kas", {
          params: {
            dari: this.filter.dari,
            sampai: this.filter.sampai,
            kategori: this.filter.kategori || undefined,
            pos: this.filter.pos || undefined,
            hanya_selesai: this.filter.hanya_selesai ? 1 : 0
          }
        });
        this.data = res.data || [];
        this.appliedFilter = { ...this.filter };
      } catch (err) {
        alert(err.response?.data?.message || "Gagal memuat data");
      } finally {
        this.state.loading = false;
        this.state.loaded = true;
      }
    },
    async fetchKategori() {
      try {
        const res = await axios.get("master-data?kategori=kategori_pengeluaran");
        this.items.kategori = (res.data || []).map(d => d.nama);
      } catch (err) {
        // abaikan, kategori tetap bisa diketik dari data
      }
    },
    async fetchKaryawan() {
      try {
        const res = await axios.get("karyawan");
        this.items.karyawan = (res.data || []).map(item => ({
          text: item.nama,
          value: item.user_id
        }));
      } catch (err) {
        // abaikan
      }
    },
    userId(val) {
      if (val && typeof val === "object") return val.user_id;
      return val ? parseInt(val) : null;
    },
    namaUser(val) {
      if (val && typeof val === "object") return val.nama || "";
      const found = this.items.karyawan.find(k => k.value == val);
      return found ? found.text : "";
    },
    isSelesai(item) {
      const v = item.selesai;
      return v === null || v === undefined || v === true || v == 1;
    },
    openEdit(item) {
      // Pastikan kategori lama tetap muncul di pilihan
      if (item.kategori && !this.items.kategori.includes(item.kategori)) {
        this.items.kategori.push(item.kategori);
      }

      this.edit.form = {
        id: item.id,
        tgl: toISODate(item.tgl),
        kategori: item.kategori,
        pos: item.pos ? item.pos.toUpperCase() : null,
        oleh: this.userId(item.oleh),
        acc: this.userId(item.acc),
        jumlah: Math.abs(Number(item.nominal) || 0),
        keperluan: item.keperluan,
        selesai: this.isSelesai(item),
        // dipertahankan agar tidak terhapus saat update
        kc: item.kc || null,
        kv: item.kv || null
      };
      this.edit.open = true;
    },
    async saveEdit() {
      const f = this.edit.form;
      if (!f.tgl || !f.kategori || !f.oleh || !f.acc || !f.keperluan) {
        alert("Tanggal, Kategori, Oleh, ACC dan Keperluan wajib diisi");
        return;
      }
      if (!f.jumlah || f.jumlah <= 0) {
        alert("Jumlah harus lebih dari 0");
        return;
      }

      this.edit.saving = true;
      try {
        await axios.put(`kas/biaya-lain/${f.id}`, {
          jenis_kas: "keluar",
          tgl: f.tgl,
          kategori: f.kategori,
          pos: f.pos || "",
          oleh: f.oleh,
          acc: f.acc,
          jumlah: f.jumlah,
          keperluan: f.keperluan,
          selesai: f.selesai,
          kc: f.kc,
          kv: f.kv
        });
        this.edit.open = false;
        await this.fetchData();
      } catch (err) {
        alert(err.response?.data?.message || "Gagal menyimpan perubahan");
      } finally {
        this.edit.saving = false;
      }
    },
    printDocument() {
      window.print();
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return "-";
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(Number(num) || 0);
    },
    convertToAngka(nilai) {
      if (nilai === null || nilai === undefined) return 0;
      const str = String(nilai);
      if (str === "" || str === "0") return 0;
      const [angka, desimal] = str.split(",");
      const bulat = angka.replace(/[^\d]/g, "");
      const hasil = parseFloat(desimal ? `${bulat}.${desimal}` : bulat);
      return Number.isNaN(hasil) ? 0 : hasil;
    }
  },
  created() {
    this.fetchKategori();
    this.fetchKaryawan();
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report-title-light {
  font-weight: 400;
  text-decoration: underline;
}

.border {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  line-height: 1;
  padding: 0 5px;
}

.border h2 {
  text-decoration: none;
}

.w-100 {
  width: 100%;
}

table {
  border-collapse: collapse;
}

table.rekap {
  min-width: 50%;
}

table th,
table td {
  font-size: 12px !important;
  border: 1px solid gray !important;
  padding: 2px 4px;
}

th {
  font-weight: bold !important;
  background-color: #f5f5f5;
}

.no-wrap {
  white-space: nowrap;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>
